class ImageFileData {
    constructor() {
        this.name = "";
        this.content = null;
    }
}
export default ImageFileData